const sa2022Tooltip =
  'SIG gathers pertinent information to determine how security risks are managed across a spectrum of 18 risk control areas, or “domains”, within a service provider’s environment. It was developed through the collective intelligence of our Membership to enable a service provider to compile complete information about these risk domains in one document.';

export default sa2022Tooltip;
